import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Layers, LayoutTemplate, LayoutDashboard, GitMerge, FlaskConical, CheckCircle2 } from 'lucide-react';
const services = [{
  title: 'App Development',
  description: 'Marketplaces, SaaS platforms, and custom dashboards built for scale.',
  icon: Layers
}, {
  title: 'Landing Page & Validation',
  description: 'High-converting landing pages designed to test and validate your product ideas.',
  icon: LayoutTemplate
}, {
  title: 'Client Dashboards',
  description: 'Secure admin panels and client portals to manage your business data.',
  icon: LayoutDashboard
}, {
  title: 'Workflow Automation',
  description: 'Custom tools to automate repetitive tasks and streamline your operations.',
  icon: GitMerge
}, {
  title: 'Product Prototypes',
  description: 'Interactive prototypes to test customer demand before writing code.',
  icon: FlaskConical
}];
export function OurServices() {
  return <section className="w-full bg-white py-24 md:py-32 border-t border-neutral-100" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6" data-id="element-85">
        <div className="max-w-3xl mb-20" data-id="element-86">
          <FadeIn data-id="element-87">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-88">
              Our Services
            </h2>
            <p className="text-xl text-neutral-500 leading-relaxed" data-id="element-89">
              We help founders and businesses launch software products quickly
              through structured MVP development.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-90">
          {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-91">
              <div className="group h-full p-8 rounded-2xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300 border border-transparent hover:border-neutral-200" data-id="element-92">
                <div className="w-12 h-12 rounded-lg bg-white border border-neutral-100 flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-93">
                  <service.icon className="w-6 h-6 text-neutral-900" data-id="element-94" />
                </div>
                <h3 className="text-xl font-semibold text-neutral-900 mb-3" data-id="element-95">
                  {service.title}
                </h3>
                <p className="text-neutral-500 leading-relaxed" data-id="element-96">
                  {service.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="mt-16 pt-8 border-t border-neutral-100" data-id="element-97">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 text-neutral-600 bg-neutral-50/50 p-6 rounded-xl border border-neutral-100" data-id="element-98">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-99">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-100" />
            </div>
            <p className="text-lg font-medium" data-id="element-101">
              Each project is delivered in milestones with clear deliverables
              and approval stages.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}